import { prefix, ajax } from './common';

export async function getAccountBrands(account_id) {
    return await ajax({
        url: prefix + '/accounts/' + account_id + '/brands'
    });
}

export async function updateAccountBrands(account_id, brand_id) {
    return await ajax({
        method: 'POST',
        url: prefix + '/accounts/' + account_id + '/brands/' + brand_id,
        data:{
            account_id,
            brand_id
        }
    });
}

export async function deleteAccountBrand(account_id, brand_id) {
    return await ajax({
        method: 'DELETE',
        url: prefix + '/accounts/' + account_id + '/brands/' + brand_id
    });
}